import React from 'react';
import {useContext, useState} from 'react'
import Navbar from '../components/NavigationBar';
import {UserContext} from '../context/UserContext';

const Register = () => {
    const {registerUser, wait} = useContext(UserContext);
    const [errMsg, setErrMsg] = useState<string>('');
    const [successMsg, setSuccessMsg] = useState<string>('');
    const [formData, setFormData] = useState({
        name:'',
        email:'',
        password:''
    });

    const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({
            ...formData,
            [e.target.name]:e.target.value
        })
    }

    const submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if(!Object.values(formData).every(val => val.trim() !== '')){
            setSuccessMsg('');
            setErrMsg('Kérlek, hogy töltsd ki az összes kötelező mezőt!');
            return;
        }

        const data = await registerUser(formData);
        if(data.success){
            const form = e.target as HTMLFormElement;
            form.reset();
            setSuccessMsg('Sikeres regisztráció');
            setErrMsg('');
        }
        else if(!data.success && data.message){
            setSuccessMsg('');
            setErrMsg(data.message);
        }
        
    }

    return (
        <>
            <Navbar />
            <div className="myform">
                <h2>Ùj admin hozzádadása</h2>
                <form onSubmit={submitForm}>
                    <label htmlFor="name">Név:</label>
                    <input type="text" name="name" onChange={onChangeInput} placeholder="Név" id="name" value={formData.name} required />
                    <label htmlFor="email">Email:</label>
                    <input type="email" name="email" onChange={onChangeInput} placeholder="Email" id="email" value={formData.email} required />
                    <label htmlFor="password">Jelszó:</label>
                    <input type="password" name="password" onChange={onChangeInput} placeholder="Jelszó" id="password" value={formData.password} required />
                    {successMsg && <div className="success-msg">{successMsg}</div>}
                    {errMsg && <div className="err-msg">{errMsg}</div>}
                    <button type="submit" disabled={wait}>Hozzáadás</button>
                </form>
            </div>
        </>
    )
}

export default React.memo(Register);
